import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import supabase from '../supabase/supabase';
import { VERTICALS, getVertical } from '../common/verticals';
import { useCollective } from '../context/CollectiveContext';

const { FiFacebook, FiMapPin } = FiIcons;

const HOME_SLUG = 'surprise';

export default function Footer() {
  const collective = useCollective();
  const [expansionCities, setExpansionCities] = useState([]);

  useEffect(() => {
    if (collective) return; // dedicated domain — skip fetching other cities
    supabase
      .from('cities_1715634000000')
      .select('id, name, slug, vertical')
      .eq('is_active', true)
      .neq('slug', HOME_SLUG)
      .order('name')
      .then(({ data }) => {
        if (data) setExpansionCities(data);
      });
  }, [collective]);

  // Group cities by vertical
  const grouped = VERTICALS.map(vert => ({
    vert,
    cities: expansionCities.filter(c => (c.vertical || 'event-planning') === vert.id),
  })).filter(g => g.cities.length > 0);

  return (
    <footer className="bg-brand-dark text-brand-cream/60 py-16 border-t-[8px] border-brand-blue">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-10">
          <div className="text-center md:text-left border-y md:border-y-0 border-white/10 py-8 md:py-0">
            <p className="font-black text-white uppercase tracking-tight text-lg mb-4">Expansion Cities</p>
            {expansionCities.length > 0 ? (
              <div className="space-y-5 mb-4">
                {grouped.map(({ vert, cities }) => (
                  <div key={vert.id}>
                    <span
                      className="inline-block text-[10px] font-black uppercase tracking-widest px-2 py-0.5 rounded text-white mb-2"
                      style={{ backgroundColor: vert.hex }}
                    >
                      {vert.label}
                    </span>
                    <ul className="space-y-1.5">
                      {cities.map(city => (
                        <li key={city.id}>
                          <Link
                            to={`/${city.slug}`}
                            className="inline-flex items-center gap-2 hover:text-white transition-colors font-bold underline underline-offset-4 decoration-2"
                            style={{ color: vert.hex }}
                          >
                            <SafeIcon icon={FiMapPin} /> {city.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-brand-cream/30 text-sm font-bold mb-4">More cities coming soon</p>
            )}
            {collective ? (
              <p className="text-xs font-bold uppercase tracking-widest" style={{ color: collective.v.hex }}>
                {collective.v.collective} · {collective.label}
              </p>
            ) : (
              <p className="text-xs font-bold uppercase tracking-widest text-brand-cream/40">
                Home Services · West Valley, Arizona
              </p>
            )}
          </div>

          <div className="flex flex-col items-center md:items-end gap-4">
            <p className="text-xs font-black uppercase tracking-widest text-brand-cream/40">Connect with us</p>
            <a
              href="https://www.facebook.com/thegyrohero"
              target="_blank"
              rel="noopener noreferrer"
              className="w-14 h-14 rounded-2xl bg-white/5 flex items-center justify-center hover:bg-[#1877F2] hover:text-white transition-all border-2 border-white/10 hover:border-[#1877F2] hover:-translate-y-1 text-white"
            >
              <SafeIcon icon={FiFacebook} className="text-2xl" />
            </a>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 text-center text-[10px] text-brand-cream/40 uppercase tracking-[0.3em] font-black">
          &copy; {new Date().getFullYear()} Mailbox Digital • Home Services Collective • West Valley, Arizona
        </div>
      </div>
    </footer>
  );
}
